module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/inspiration-toolbar.5f7a009a.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/inspiration-toolbar.png
// module id = 3723
// module chunks = 11